import { ParentRole } from "./features/ParentRolesPage/Models/ParentRole";
import { Privilege } from "./features/PrivilegesPage/Models/Privilige";
import { SubRole } from "./features/SubRolesPage/Models/SubRole";
import { PrivilegeUpdate } from "./features/PrivilegesPage/Models/PrivilegeUpdate";

//TODO: Use environement variables when connection to backend has been tested
const BASE_URL =
  "https://ca-roles-privileges-poa-dev-weu.greenisland-9557aaed.westeurope.azurecontainerapps.io/api/v1";
export const PARENT_ROLES_ENDPOINT: string = "parent-roles";
export const SUB_ROLES_ENDPOINT: string = "sub-roles";
export const PRIVILEGES_ENDPOINT: string = "privileges";
export const PARENT_ROLES_OVERVIEW_ENDPOINT: string = "parent-roles/overview";
export const PARENT_ROLES_AMOUNT_ENDPOINT: string = "parent-roles/amount";
export const SUB_ROLES_OVERVIEW_ENDPOINT: string = "sub-roles/overview";
export const SUB_ROLES_DETAILED_OVERVIEW_ENDPOINT: string =
  "sub-roles/detailed-overview";
export const SUB_ROLES_AMOUNT_ENDPOINT: string = "sub-roles/amount";
export const PRIVILEGES_OVERVIEW_ENDPOINT: string = "privileges/overview";
export const PRIVILEGES_AMOUNT_ENDPOINT: string = "privileges/amount";
export const ROLES_PRIVILEGES_OVERVIEW_ENDPOINT: string =
  "roles-privileges-overview";

type RolePrivilegeType = ParentRole | SubRole | Privilege | PrivilegeUpdate;

export async function postRequest(endpoint: string, data: RolePrivilegeType) {
  const token = JSON.parse(localStorage.getItem("tokens")!);
  const accessToken = token.accessToken;

  const response = await fetch(`${BASE_URL}/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
}

export async function putRequest(
  endpoint: string,
  data: RolePrivilegeType,
  id: string
) {
  const token = JSON.parse(localStorage.getItem("tokens")!);
  const accessToken = token.accessToken;

  const response = await fetch(`${BASE_URL}/${endpoint}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
}

export async function getRequest(endpoint: string, parameter?: string) {
  const token = JSON.parse(localStorage.getItem("tokens")!);
  const accessToken = token.accessToken;

  const response = await fetch(`${BASE_URL}/${endpoint}/${parameter ?? ""}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
}

export async function deleteRequest(endpoint: string, id: string) {
  const token = JSON.parse(localStorage.getItem("tokens")!);
  const accessToken = token.accessToken;

  const response = await fetch(`${BASE_URL}/${endpoint}/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
}
